import React, { useMemo } from 'react';

const EmbedYoutube = ({link, iframeRef}) => {
    const emdedLink = useMemo(() => {
        if (link.includes('youtube.com/embed')) {
            return link;
        }

        const linkId = new URLSearchParams(new URL(link).search).get('v');
        
        return linkId ? `https://www.youtube.com/embed/${linkId}` : null;
    }, [link]);
    
    if (!emdedLink) {
        return (<></>)
    }

    return (
        <iframe
            ref={iframeRef}
            width="900"
            height="532"
            src={emdedLink}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
        />
    )
};

export default EmbedYoutube;

